var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Form } from 'react-final-form';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import FilterActions, { defaultLabels } from './FilterActions';
var useStyles = makeStyles(function (theme) { return ({
    paper: {
        borderRadius: theme.spacing(2),
        boxShadow: '0px 4px 20px rgba(0,0,0,0.1)',
        backgroundColor: 'white',
        padding: theme.spacing(2),
    },
}); });
function Filter(_a) {
    var children = _a.children, labels = _a.labels, onSubmit = _a.onSubmit, initialValues = _a.initialValues, onClear = _a.onClear, noPaper = _a.noPaper, customActions = _a.customActions, rest = __rest(_a, ["children", "labels", "onSubmit", "initialValues", "onClear", "noPaper", "customActions"]);
    var classes = useStyles();
    var handleClear = function (_, form) {
        form.reset({});
        onClear();
    };
    var Container = noPaper ? 'div' : Paper;
    return (React.createElement(Form, __assign({ onSubmit: onSubmit, initialValues: initialValues }, rest), function (_a) {
        var handleSubmit = _a.handleSubmit, form = _a.form;
        return (React.createElement(Container, { classes: { root: classes.paper } },
            React.createElement("form", { onSubmit: handleSubmit },
                React.createElement(Grid, { container: true, spacing: 2 },
                    React.createElement(Grid, { item: true, xs: 12 }, children),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(FilterActions, { onClear: function (e) { return handleClear(e, form); }, labels: labels, customActions: customActions }))))));
    }));
}
Filter.defaultProps = {
    labels: defaultLabels,
    noPaper: false,
};
export default Filter;
//# sourceMappingURL=Filter.js.map